export class ValidatePassword {
    constructor() {
        this.elementPassword = document.querySelector('input[type="password"]');

        if (this.elementPassword){
            this.elementPassword.addEventListener('keypress', (e) => {
                let keyCode = e.keyCode;
                if (keyCode === 32){
                    e.preventDefault();
                }
            })
        }
    }
}